import React, { useState, useRef, useEffect } from "react";
import { Icon } from "semantic-ui-react";
import { AccidentsTable } from "../../../components/Admin/Accidents/AccidentsTable";
// import { AccidentsDashboard } from "../../../components/Admin/Accidents/AccidentsDashboard";
import { ManagementModuleTitle } from "../../../components/Shared";
import { useLanguage, useSite } from "../../../contexts";
import { useCompany } from "../../../contexts/CompanyContext";
import "./Accidents.scss";

const CURRENT_YEAR = new Date().getFullYear();

export function Accidents() {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;
  const [reload,     setReload]     = useState(false);
  const [triggerNew, setTriggerNew] = useState(0);
  const [year,       setYear]       = useState(CURRENT_YEAR);
  const [extSearch,  setExtSearch]  = useState("");
  const onReload = () => setReload((prev) => !prev);
  const { site }    = useSite();
  const { company } = useCompany();

  const hasCompany = company && company !== "0" && company !== 0;

  const yearOptions = Array.from({ length: 5 }, (_, i) => CURRENT_YEAR - 2 + i).reverse();

  const [showYearMenu, setShowYearMenu] = useState(false);
  const yearMenuRef = useRef(null);

  useEffect(() => {
    if (!showYearMenu) return;
    const handler = (e) => {
      if (yearMenuRef.current && !yearMenuRef.current.contains(e.target))
        setShowYearMenu(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [showYearMenu]);

  return (
    <div className="accidents-page">
      <div className="acc-title-bar">
        <ManagementModuleTitle labelClassName="acc-title-bar__title" />
      </div>

      <div className="acc-year-bar" ref={yearMenuRef}>
        <button
          type="button"
          className="acc-year-bar__toggle"
          onClick={() => setShowYearMenu((v) => !v)}
        >
          <span className="acc-year-bar__label">{year}</span>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" width="20" height="20" className={`acc-year-bar__arrow${showYearMenu ? " acc-year-bar__arrow--open" : ""}`}>
            <circle cx="12" cy="12" r="9"/>
            <path d="M12 8v6m0 0-2.5-2.5M12 14l2.5-2.5"/>
          </svg>
        </button>

        {showYearMenu && (
          <div className="acc-year-menu">
            {yearOptions.map((y) => (
              <button
                type="button"
                key={y}
                className={`acc-year-menu__item${y === year ? " acc-year-menu__item--active" : ""}`}
                onClick={() => { setYear(y); setShowYearMenu(false); }}
              >
                {y}
              </button>
            ))}
          </div>
        )}
      </div>

      {hasCompany ? (
        <>
          {/* <AccidentsDashboard
            extYear={year}
            onYearChange={setYear}
            onSearchChange={setExtSearch}
          /> */}
          <AccidentsTable
            reload={reload}
            onReload={onReload}
            triggerNew={triggerNew}
            extYear={year}
            extSearch={extSearch}
          />
        </>
      ) : (
        <div className="no-site-warning">
          <Icon name="building outline" />
          <p>{t("select_company_from_header") || "Selecciona una empresa desde el encabezado"}</p>
        </div>
      )}
    </div>
  );
}
